import React from 'react'
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import './App.css';
import { AuthProvider } from './utils/authContext';
import Landing from "./pages/Landing";
import Event from "./pages/Event";
import ShowRunner from './pages/ShowRunner';
import WorkWithUs from './pages/WorkWithUs';
import ResetPassword from './pages/ResetPassword';
// import Maintenance from './pages/Maintenance';
import WillCall from './pages/WillCall';
import TermsOfService from './pages/ToS';
import Floorplan from './pages/newfloorplan/Floorplan';
import LaunchEvent from './pages/LaunchEvent';
import SignUpComplete from './pages/SignUpComplete';

function App() {
  return (
    <div>
      <AuthProvider>
        <ToastContainer />
        <Routes>
          <Route path="/" element={<WorkWithUs />} />
          <Route path="/launchevent" element={<LaunchEvent />} />
          <Route path="/events" element={<Landing />} />
          <Route path="/event/:showID" element={<Event />} />
          <Route path="/showrunner/*" element={<ShowRunner />} />
          <Route path="/willcall" element={<WillCall />} />
          <Route path="/signupcomplete" element={<SignUpComplete />} />
          <Route path="/workwithus" element={<WorkWithUs />} />
          <Route path="/tos" element={<TermsOfService />} />
          <Route path="/reset-password/:uidb64/:token" element={<ResetPassword />} />
          <Route path="/floorplan" element={<Floorplan />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
